import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MomentModule } from 'angular2-moment';
import { Ng2BreadcrumbModule } from 'ng2-breadcrumb/ng2-breadcrumb';
import { AceEditorModule } from 'ng2-ace-editor';
import { DiffMatchPatchModule } from 'ng-diff-match-patch';
import { Ng4JsonEditorModule } from 'angular4-jsoneditor';
import { NgxSelectModule } from 'ngx-select-ex';
import { AngularDualListBoxModule } from 'angular-dual-listbox';

import { IconsPipe } from '../helpers/pipes/icons.pipe';
import { AuthenticatedGuard } from '../infrastructure/services/sxSecurity.service';
import { StyleService } from '../infrastructure/services/style.service';
import { DynamicFormComponent } from '../helpers/form/dynamicForm.component';
import { DynamicFormElementComponent } from '../helpers/form/elements/formElement';
import { AlertComponent } from '../helpers/components/sxAlert/alert';
import { LoaderComponent } from '../helpers/components/loader/loader.component';
import { ComboBoxComponent } from '../helpers/components/formWidgets/comboBox.component';

import { PrivateSectionLayoutComponent } from './private.section.layout';
import { HomeComponent } from './home/home.component';
import { DesktopComponent } from './desktop/desktop.component';
import { UsersSocComponent } from './users-soc/user-soc.component';

// Nabvar: Component y module
import { NavbarComponent } from "./navbar/navbar.component";
import { NavbarModule } from "./navbar/navbar.module";

// TODO: Refactor configuracion a un modulo propio
import { ConfiguracionComponent } from './configuracion/configuracion.component';
import { SistemaComponent } from './configuracion/sistema.component';
import { ChannelComponent } from './configuracion/channel.component';
import { HomeChannelConfiguracionComponent } from './configuracion/channel/home.component';
import { TimelineNegocioConfiguracionComponent } from './configuracion/channel/timeline.component';
import { ContactosComponent } from './configuracion/channel/contactos.component';
import { AddContacto } from './configuracion/channel/contactos.add.component';
import { DetalleSubscriptionComponent } from './configuracion/subscription/detalle.subscription.component';
import { ConfigurarNuevoProductComponent } from './configuracion/product/configurar.component';
import { ConfigurarFormularioProductComponent } from './configuracion/product/configurar.formulario.component';

// BUSCADOR DE PRODUCTOS
import { ProductSearchComponent } from './product-search/product-search.component';
import { ProductProviderListComponent } from './product-search/components/product-provider-list.component';
import { ProductSectionListComponent } from './product-search/components/product-section-list.component';

import { sxfDesignerModule } from './sxfdesigner/sxfdesigner.module';
import { SxDesigner } from './sxfdesigner/components/main/designer.component';

import { ListadoChannelsComponent } from './channels/listado.channels.component';
import { DetailchannelComponent } from './channels/detalle/detail.channel.component';
import { HomeChannelComponent } from './channels/detalle/home.channel.component';
import { ListadoSubscriptionsComponent } from './channels/listado.subscriptions.component';
import { ProductListComponent } from './product/product.list.component';
import { DetailProductComponent } from './product/detalle/detail.product.component';
import { HomeProductComponent } from './product/home/home.product.component';
import { ListadoDesplegableComponent } from '../helpers/components/dropdownList/dropdownList.component';
import { ProductSetupComponent } from './configuracion/product/product.setup.component';
import { RuleEditorComponent } from './reglas/reglas.editor.component';
import { DetalleAtributosComponent } from './atributos/detalle.atributos.component';
import { NotFoundComponent } from '../helpers/components/notFound/notFound.component';
import { ConfigurarSubscriptionComponent } from './configuracion/subscription/configurar.subscription.component';
import { ConfigurarTipoSolicitudComponent } from './tiposolicitud/configurar.tiposolicitud.component';
import { ListadoTipoSolicitudComponent } from './tiposolicitud/listado.tiposolicitud.component';
import { ConfigurarOpcionesComponent } from './configuracion/opciones/configurar.opciones.component';
import { SolicitudComponent } from './solicitud/solicitud.component';
import { ListadoSolicitudDisponibleComponent } from '../helpers/components/aviableSolicitudeList/aviableSolicitudeList.component';
import { ListadoAssetsComponent } from './assets/listado.assets.component';
import { DetalleAssetTextComponent } from './assets/detalle.assetText.component';
import { DetalleAssetFileComponent } from './assets/detalle.assetFile.component';
import { ListadoInitializerComponent } from './configuracion/initializer/listado.initializer.component';
import { ExportarInitializerComponent } from './configuracion/initializer/exportar/exportar.initializer.component';
import { ImportarInitializerComponent } from './configuracion/initializer/importar/importar.initializer.component';
import { TreeViewComponent } from '../helpers/components/treeView/treeView.component';
import { UsuariosModule } from './usuarios/usuarios.module';
import { ComandosUsuarioComponent } from './usuarios/comandos.usuario.component';
import { VistaComandoComponent } from './usuarios/vista.comando.component';
import { SharedModule } from '../helpers/shared.module';
import { ListadoOpcionesComponent } from './opciones/listado.opciones.component';
import { ControllerOpcionComponent } from './opciones/controller.opcion.component';
import { FormularioAtributosComponent } from './atributos/formulario.atributos.component';
import { ConfigurarChannelComponent } from './configuracion/channel/configurar.channel.component';
import { ReglasHistorialComponent } from './reglas/reglas.historial.component';
import { DesignerHistorialComponent } from './sxfdesigner/components/historial/designer.historial.component';
import { SeleccionarTipoAssetComponent } from './assets/seleccionar.tipo.asset.component';
import { SeleccionarNivelConsultaSimpleComponent } from './consultaSimple/seleccionar.nivel.consultaSimple.component';
import { ListadoConsultaSimpleComponent } from './consultaSimple/listado.consulta.simple.component';
import { ConfigurarConsultaSimpleComponent } from './consultaSimple/configurar.consulta.simple.component';
import { ParametrosListadoComponent } from './parametros/parametros.listado.component';
import { ParametroCrearComponent } from './parametros/parametro.crear.component';
import { SeleccionarTipoImportacionComponent } from './importacionMasiva/seleccionar.tipo.importacion.component';
import { UsuarioImportacionFormComponent } from './importacionMasiva/forms/usuario.importacion.form.component';
import { TarifaImportacionFormComponent } from './importacionMasiva/forms/tarifa.importacion.form.component';
import { EndosoImportacionFormComponent } from './importacionMasiva/forms/endoso.importacion.form.component';
import { ItemLibraryComponent } from './item-library/item-library.component';
import { ItemLibraryListComponent } from './item-library/item-library-list.component';
import { ItemLibraryImportComponent } from './item-library/item-library-import.component';
import { SettingsUsuarioComponent } from './settingsUsuario/settings.usuario.component';

import { ListadoSiteTemplatesComponent } from './siteTemplates/listado.siteTemplates.component';
import { SettingsEntidadComponent } from './settingsEntidad/settings.entidad.component';
import { ListadoPagesComponent } from './siteTemplates/listado.pages.component';
import { AliasChannelComponent } from './channels/alias/alias.channel.component';
import { SelectTemplateComponent } from './channels/alias/select.template.component';
import { UserPoliciesEntidadComponent } from './settingsEntidad/userPolicies.entidad.component';
import { HistorialImportacionComponent } from './configuracion/initializer/historial/historial-importacion.component';
import { ListFileManagerComponent } from '../helpers/components/listFilesManager/listFilesManager.component';

import { ListadoRolComponent } from './rol/listado.rol.component';
import { CreateRolComponent } from './rol/create-rol/create-rol.component';
import { UsersAndProfilesComponent } from './usersAndProfiles/users.and.profiles.component';
import { RolesByUserComponent } from './usersAndProfiles/user-roles/roles.by.user.component';
import { CustomersConfiguration } from './configuracion/customerTable/configurar.customer.component';
import { UserRolesComponent } from './usersAndProfiles/user-roles/user.roles.component';
import { UsersByRoleComponent } from './usersAndProfiles/user-roles/users.by.role.component';
import { FlowPreviewComponent } from './product/flow-preview/flow-preview.component';
import { CacheService } from 'app/infrastructure/services/cache.service';
import { EntitiesInformationService } from './sidebar-information/entity-information.service';

import { NonTransactionalFlowComponent } from './non-transactional-flow/non-transactional-flow.component';
import { ListOutputComponent } from "./outputs/list.output.component";
import { DetailOutputComponent } from "./outputs/detail/detail.output.component";
import { HomeOutputComponent } from "./outputs/home/home.output.component";
import { ConfigurarOutputComponent } from "./configuracion/output/configurar.output.component";
import { ImportOutputComponent } from "./outputs/import/import.output.component";
import { ConfigurationOutputComponent } from "./outputs/configuration/configuration.output.component";
import { MappingListOutputComponent } from "./outputs/mapping/mappingList.output.component";
import { ComandosUsersSocComponent } from "./users-soc/comandos.users-soc.component";
import { ListPaymentGatewaysComponent } from "./paymentGateways/list.payment.gateways.component";
import { DetailPaymentComponent } from "./paymentGateways/detail/detail.payment.component";
import { HomePaymentComponent } from "./paymentGateways/home/home.payment.component";
import { ConfigurarPaymentComponent } from "./configuracion/paymentGateway/configurar.paymentGateway.component";
import { MassiveImportComponent } from "./usuarios/massive-import.component";
import { IntaractionEventComponent } from "./dynamicFlow/IterationEventComponent/interactionEvent.component";
import { ProductFlowConfigComponent } from "./dynamicFlow/productFlowConfig.component";
import { ProductFlowListComponent } from "./dynamicFlow/productFlowList.component";
import { ImportDynamicFlowComponent } from "./dynamicFlow/importDynamicFlow/importDynamicFlow.component";
import { ExternalComponentListComponent } from "./external-component/list.external-component.component";
import { ExternalComponentEditComponent } from "./external-component/edit/edit.external-component.component";
import { JobScheduleConfigurationComponent } from "./outputs/Schedule/Configuration/jobScheduleConfiguration.component";
import { MappingDetailsOutputComponent } from "./outputs/mapping/mappingDetails.output.component";
import { QueryBuilderModule } from "app/plugins/queryBuilder";
import { ListReportConfigurationComponent } from "./reportConfiguration/list.report.configuration.component";
import { EditReportConfigurationComponent } from "./reportConfiguration/edit.report.configuration.component";
import { PushConfigurationComponent } from "./outputs/pushConfiguration/pushConfiguration.component";
import { CurrencyConfigurationComponent } from "./configuracion/currency/configurar.currency.component";
import { DigitalLibraryListComponent } from "./digital-library/digital-library-list.component";
import { DigitalLibraryImportComponent } from "./digital-library/import/digital-library-import.component";
import { DigitalLibraryProgressComponent } from "./digital-library/progress/digital-library-progress.component";
import { ListproductReportConfigurationComponent } from "./product/productReport/list.productreport.component";
import { DetailProductReportComponent } from "./product/productReport/deatils/detail.productreport.component";
import { ImportProductReportComponent } from "./product/productReport/import/import.productreport.component";
import { ConfigurarProductReportComponent } from "./configuracion/productReport/configurar.productReport.component";
import { MappingListProductReportComponent } from "./product/productReport/mapping/mappingList.productReport.component";
import { MappingDetailsProductReportComponent } from "./product/productReport/mapping/mappingDetails.productReport.component";
import { RulesModule } from "./reglas/rules.module";
import { MappingListReportConfigurationComponent } from "./reportConfiguration/mapping/mappingList.reportconfiguration.component";
import { MappingDetailsReportConfigurationComponent } from "./reportConfiguration/mapping/mappingDetails.reportconfiguration.component";
import { AuthorizationConfigurationChannelComponent } from "./channels/authorizationConfiguration/authorizationConfiguration.channel.component";
import { DigitalLibraryPublishComponent } from "./digital-library/publish/digital-library-publish.component";
import { CountryTransform } from "app/helpers/pipes/country.pipe";
import { ProductFlowDynamicStylesComponent } from "./dynamicFlow/DynamicStyleConfiguration/dynamicStyleConfiguration.component";
import { EntityInformationComponent } from "./sidebar-information/entity-information.component";
import { SettingChannelComponent } from "./configuracion/setting-channel/setting-channel.component";
import { EntityWithChildsComponent } from "./entity/entityWithChilds/entiy-with-childs.component";
import { entityWithChildsModule } from "./entity/entityWithChilds/entity-with-childs.module";
import { EntityListComponent } from "./entity/entityList/entity-list.component";
import { ProductStandardFlowListComponent } from "./dynamicFlow/productStandardFlowList.component";
import { DetalleOrganizacionComponent } from "./configuracion/organizacion/detalle.organizacion.component";
import { ListViewEngineComponent } from "./viewengine/list.viewengine.component";
import { ViewEngineEditComponent } from "./viewengine/edit/edit.viewengine.component";
import { PortalsComponent } from "./portals/portals.component";
import { BaseDynamicListDesignerComponent } from "./sxfdesigner/components/designers/layout/flow-actions/base.dynamic.list.component";
import { DataLogicComponent } from "./datalogic/data-logic.component";
import { DetailDataLogicComponent } from "./datalogic/detail/detail-data-logic.component";
import { BusinessLogicListComponent } from "./businesslogic/business-logic-list.component";
import { DetailBusinessLogicComponent } from "./businesslogic/detail/detail-business-logic.component";
import { SubscribeBusinessLogicComponent } from "./businesslogic/subscribe/subscribe-business-logic.component";
import { SOCRoleComponent } from "./soc-role/create-rol/soc-role.component";
import { SOCRoleListComponent } from "./soc-role/soc-role-list.component";
import { StandardDcitionaryComponent } from "./standard-dictionary/standard-dictionary.component";
import { DetailStandardDictionaryComponent } from "./standard-dictionary/detail/detail-standard-dictionary.component";
import {SubscribeReportConfigurationComponent} from "./reportConfiguration/subscribe/subscribe.report.configuration.component";
import {ReportConfigurationSubscriptionListComponent} from "./reportConfiguration/subscribe/subscribe-list/report.configuration.subscription.list.component";
import {ProductEmailSubscriptionListComponent} from "./product-email/subscribe/subscribe-list/product.email.subscription.list.component";
import {SubscribeProductEmailComponent} from "./product-email/subscribe/subscribe.product.email.component";
import {ProductReportSubscriptionListComponent} from "./product/productReport/subscribe/subscribe-list/product.report.subscription.list.component";
import {SubscribeProductReportComponent} from "./product/productReport/subscribe/subscribe.productreport.component";
import { AutoCompleteModule } from 'ng4-auto-complete';
import {ConfigurationCenterComponent} from './configuration-center/configuration.center.component'
import { MarketplaceComponent } from './marketplace/marketplace.component';
import { MarketplaceDropdown } from './marketplace/marketplace-dropdown/marketplace-dropdown.component';
import { MarketplaceFilter } from './marketplace/marketplace-filter/marketplace-filter.component';
import { MarketplaceCard } from './marketplace/marketplace-card/marketplace-card.component';

//types
import { MARKETPLACE_ITEMTYPE_StandardFlow, MARKETPLACE_ITEMTYPE_BusinessLogic } from 'app/infrastructure/services/marketplace.service';
import { MarketplaceSubscriptionComponent } from './marketplace/marketplace-subscription.component';
import { I18NextModule } from 'angular-i18next';
import { ListadoResourcesComponent } from './resources/listado.resources.component';
import { DetailResourcesComponent } from './resources/detail.resources.component';

const ROUTES: Routes = [
  { path: '', component: DesktopComponent, pathMatch: 'full' },
  { path: '404', component: NotFoundComponent },
  {
    path: 'resources',
    children: [
      { 
        path: '', 
        component: ListadoResourcesComponent
      },
      { 
        path: 'viewResource/:idResource', 
        component: DetailResourcesComponent
      },
    ]
  },
  {
    path: 'nontransactionalflows',
    children: [
        {
            path: '',
            component: NonTransactionalFlowComponent,
        },
        {
            path: ':flowId',
            children: [
                {
                    path: '',
                    component: NonTransactionalFlowComponent,
                },
                {
                    path: 'interactionEvent/:eventType/:codCommand',
                    component: IntaractionEventComponent,
                },
                {
                    path: 'interactionEvent',
                    redirectTo: '',
                },

                {
                    path: 'designer',
                    children: [
                        { path: '', component: SxDesigner },
                        { path: ':pageId', component: SxDesigner },
                    ],
                },
            ],
        },
    ],
  },
  {
    path: 'viewengine',
    children: [
      { path: '', component: ListViewEngineComponent },
      {
        path: ':codviewengine',
        component: ViewEngineEditComponent,
      },
    ],
  },
  {
    path: 'marketplace',
    children: [
      {
        path: '',
        component: MarketplaceComponent,
      }
    ],
  },
  {
    path: 'businessLogic',
    children: [
      {
        path: '',
        component: BusinessLogicListComponent,
      },
      {
        path: 'New',
        component: DetailBusinessLogicComponent,
      },
      {
        path: ':codbusinesslogic',
        component: DetailBusinessLogicComponent,
      },
    ],
  },
  {
    path: 'dataLogic',
    children: [
      {
        path: '',
        component: DataLogicComponent,
      },
      {
        path: 'New',
        component: DetailDataLogicComponent,
      },
      {
        path: ':coddatalogic',
        component: DetailDataLogicComponent,
      },
    ],
  },
  {
    path: "configurationCenter",
    children: [
      { 
        path: "", 
        component: ConfigurationCenterComponent
      },
      {
        path: "confReport",
        children: [
          {
            path: "",
            component: ListReportConfigurationComponent
          },
          {
            path: ":codreporte",
            component: EditReportConfigurationComponent
          },
    
          {
            path: ":codreporte/mapping",
            component: MappingListReportConfigurationComponent
          },
          {
            path: ":codreporte/mapping/:mappingId",
            component: MappingDetailsReportConfigurationComponent
          },
          {
            path: ":codreporte/confRegla/:codRegla",
            component: RuleEditorComponent
          }
        ]
      },
      {
        path: 'emails',
        loadChildren:
          'app/private/product-email/product-email.module#ProductEmailModule',
      },
      {
        path: 'confProductReport',
        children: [
          {
            path: '',
            component: ListproductReportConfigurationComponent,
          },
          {
            path: ':productReportCode',
            children: [
              {
                path: '',
                component: DetailProductReportComponent,
              },
              {
                path: 'config',
                children: [
                  {
                    path: '',
                    component: ConfigurarProductReportComponent,
                  },
                  {
                    path: 'import',
                    component: ImportProductReportComponent,
                  },                                        
                  {
                    path:
                      'confRegla/:codRegla/historial',
                    component: ReglasHistorialComponent,
                  }
                ],
              },
              {
                path: 'mapping/:mappingId',
                component: MappingDetailsProductReportComponent,
              },
              {
                path: 'confRegla/:codRegla',
                component: RuleEditorComponent,
              },
            ],
          },
        ],
      }
    ]
  },
  {
    path: "standarddictionary",
    children: [
      {
        path: '',
        component: StandardDcitionaryComponent,
      },
      {
        path: 'New',
        component: DetailStandardDictionaryComponent,
      },
      {
        path: ':codstandarddictionary',
        component: DetailStandardDictionaryComponent,
      },
    ],
  },
  {
    path: 'users',
    children: [
      {
        path: '',
        component: UsersSocComponent,
      },
      { path: 'profilesAdmin', component: SOCRoleListComponent },
      { path: 'profilesAdmin/nuevo', component: SOCRoleComponent },
      { path: 'profilesAdmin/editar/:rolecode', component: SOCRoleComponent },
      {
        path: 'profilesAdmin/profilesAdmin/editar',
        component: CreateRolComponent,
      },
      { path: "userProfilesAdmin", component: UserRolesComponent },
      {
        path: 'service',
        children: [
          { path: '', component: ComandosUsersSocComponent },
          {
            path: 'UserPolicies/:tipo',
            component: UserPoliciesEntidadComponent,
          },
          {
            path: ':mode',
            children: [
              { path: '', component: ComandosUsersSocComponent },
              {
                path: 'confFormulario/:codFormulario',
                component: FormularioAtributosComponent,
              },
              {
                path: 'confFormulario/:codFormulario/:codAtributo',
                component: DetalleAtributosComponent,
              },
              {
                path: 'confFormulario/:codFormulario/:codAtributo/:codNestForm',
                component: DetalleAtributosComponent,
              },
              { path: 'import', component: MassiveImportComponent },
              {
                path: 'usersAdmin/:codcomando',
                component: VistaComandoComponent,
              },
              {
                path: 'usersAdmin/:codcomando/:id',
                component: VistaComandoComponent,
              },
              { path: "usersAdmin", component: ComandosUsersSocComponent },

                            { path: "userProfilesAdmin/:id", component: UserRolesComponent },

              {
                path: 'designer/:codservicio/:codcomando',
                component: SxDesigner,
              },
              {
                path: 'designer/:codservicio/:codcomando/:listPath',
                component: SxDesigner,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'itemLibrary',
    children: [
      { path: '', component: ItemLibraryListComponent },
      { path: ':codlibrary', component: ItemLibraryComponent },
      { path: ':codlibrary/import', component: ItemLibraryImportComponent },
    ],
  },
  {
    path: 'sxfdesigner',
    children: [
      { path: '', component: SxDesigner },
      { path: ':id', component: SxDesigner },
    ],
  },
  {
    path: 'organizations',
    children: [
      {
        path: '',
        component: EntityListComponent,
      },
      {
        path: 'nuevo',
        component: DetalleOrganizacionComponent,
      },
      {
        path: ':codorganizacion',
        children: [
          {
            path: '',
            component: EntityWithChildsComponent,
          },
          {
            path: 'edit',
            component: DetalleOrganizacionComponent,
          },
          {
            path: 'subscriptions/nuevo',
            component: DetalleSubscriptionComponent,
          },
          // NAVEGACION DE SISTEMAS
          {
            path: 'subscriptions/:codsistema',
            children: [
              {
                path: '',
                component: EntityWithChildsComponent,
              },
              {
                path: 'edit',
                component: DetalleSubscriptionComponent,
              },
              {
                path: 'confSistema',
                children: [
                  {
                    path: '',
                    component: ConfigurarSubscriptionComponent,
                  },
                  {
                    path: 'confRegla/:codRegla',
                    component: RuleEditorComponent,
                  },
                  {
                    path: 'confRegla/:codRegla/historial',
                    component: ReglasHistorialComponent,
                  },
                  { path: 'solicitud', component: SolicitudComponent },
                  {
                    path: 'categoriasProducto',
                    loadChildren:
                      'app/private/categorias-producto/categorias-producto.module#CategoriasProductoModule',
                  },
                  {
                    path: 'confFormulario/:codFormulario',
                    children: [
                      {
                        path: '',
                        component: FormularioAtributosComponent,
                      },
                      {
                        path: ':codAtributo',
                        component: DetalleAtributosComponent,
                      },
                      {
                        path: ':codAtributo/:codNestForm',
                        component: DetalleAtributosComponent,
                      },
                      {
                        path: ':codAtributo/:codNestForm',
                        component: FormularioAtributosComponent,
                      },
                    ],
                  },
                  {
                    path: 'sxfdesigner/:codservicio/:codcomando',
                    children: [
                      {
                        path: '',
                        component: SxDesigner,
                      },
                      {
                        path: ':listPath',
                        component: SxDesigner,
                      },
                      {
                        path: 'historial/:codForm',
                        component: DesignerHistorialComponent,
                      },
                    ],
                  },
                  { path: 'settings', component: SettingsEntidadComponent },
                  {
                    path: 'settings/:tipo',
                    component: UserPoliciesEntidadComponent,
                  },
                  // {
                  //   path: 'externalComponents',
                  //   component: ExternalComponentListComponent,
                  // },
                  // {
                  //   path: 'externalComponents/:alias',
                  //   component: ExternalComponentEditComponent,
                  // },

                  // Routing for Payment Gateways
                  {
                    path: 'PaymentGateways',
                    children: [
                      {
                        path: '',
                        component: ListPaymentGatewaysComponent,
                      },
                      {
                        path: ':optype',
                        children: [
                          { path: '', component: DetailPaymentComponent },
                          {
                            path: ':pgcode',
                            children: [
                              { path: '', component: DetailPaymentComponent },
                              {
                                path: 'confPayment',
                                children: [
                                  {
                                    path: '',
                                    component: ConfigurarPaymentComponent,
                                  },
                                  {
                                    path: 'confRegla/:codRegla',
                                    component: RuleEditorComponent,
                                  },
                                  {
                                    path: 'confFormulario/:codFormulario',
                                    component: FormularioAtributosComponent,
                                  },
                                  {
                                    path:
                                      'confFormulario/:codFormulario/:codAtributo',
                                    component: DetalleAtributosComponent,
                                  },
                                  {
                                    path:
                                      'confFormulario/:codFormulario/:codAtributo/:codNestForm',
                                    component: FormularioAtributosComponent,
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },

                  // ROUTING FOR OUTPUTS
                  {
                    path: 'outputs',
                    children: [
                      { path: '', component: ListOutputComponent },
                      {
                        path: ':codoutput',
                        children: [
                          { path: '', component: DetailOutputComponent },
                          {
                            path: 'confOutput',
                            children: [
                              {
                                path: '',
                                component: ConfigurarOutputComponent,
                              },
                              {
                                path: 'import',
                                component: ImportOutputComponent,
                              },
                              {
                                path: 'configuration',
                                component: ConfigurationOutputComponent,
                              },
                              {
                                path: 'pushConfiguration',
                                component: PushConfigurationComponent,
                              },
                              {
                                path: 'mapping',
                                component: MappingListOutputComponent,
                              },
                              {
                                path: 'mapping/:mappingId',
                                component: MappingDetailsOutputComponent,
                              },
                              {
                                path: 'confRegla/:codRegla',
                                component: RuleEditorComponent,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                path: 'opciones',
                children: [
                  { path: '', component: ConfigurarOpcionesComponent },
                  // ROUTING PARAMETROS DEL SISTEMA
                  { path: 'parametros', component: ParametrosListadoComponent },
                  // Azure File Manager
                  { path: 'filemanager', component: ListFileManagerComponent },

                  // ROUTING IMPORTACION MASIVA
                  {
                    path: 'importacion',
                    children: [
                      {
                        path: '',
                        component: ListadoChannelsComponent,
                        data: { ocultarNuevo: true },
                      },
                      {
                        path: ':codnegocio',
                        component: ProductListComponent,
                        data: { ocultarNuevo: true },
                      },
                      {
                        path: ':codnegocio/:codproducto',
                        component: SeleccionarTipoImportacionComponent,
                      },
                    ],
                  },
                  // ROUTING RESTAURAR ENTIDADES
                  {
                    path: 'restaurarEntidades',
                    loadChildren:
                      'app/private/restaurarEntidades/restaurar-entidades.module#RestaurarEntidadesModule',
                  },
                  // NAVEGACION INITIALIZER
                  {
                    path: 'initializer',
                    children: [
                      { path: '', component: ListadoInitializerComponent },
                      {
                        path: 'exportar',
                        component: ExportarInitializerComponent,
                      },
                      {
                        path: 'importar',
                        component: ImportarInitializerComponent,
                      },
                      {
                        path: 'historial',
                        component: HistorialImportacionComponent,
                      },
                    ],
                  },
                  // ROUTING DIAGNOSTICO
                  {
                    path: 'diagnosticos',
                    loadChildren:
                      'app/private/diagnosticos/diagnosticos.module#DiagnosticosModule',
                  },
                  // TEST API
                  {
                    path: 'testapi',
                    loadChildren:
                      'app/private/testApi/testApi.module#TestApiModule',
                  },
                  // CONSULTA SIMPLE
                  {
                    path: 'consultaSimple',
                    children: [
                      {
                        path: '',
                        component: SeleccionarNivelConsultaSimpleComponent,
                      },
                      {
                        path: 'sistemas',
                        children: [
                          {
                            path: '',
                            component: ListadoConsultaSimpleComponent,
                          },
                          {
                            path: ':codcomando',
                            component: ConfigurarConsultaSimpleComponent,
                          },
                          {
                            path: ':codcomando/confFormulario/:codFormulario',
                            component: FormularioAtributosComponent,
                          },
                          {
                            path:
                              ':codcomando/confFormulario/:codFormulario/:codAtributo',
                            component: DetalleAtributosComponent,
                          },
                          {
                            path:
                              ':codcomando/confFormulario/:codFormulario/:codAtributo/:codNestForm',
                            component: FormularioAtributosComponent,
                          },
                          {
                            path: ':codcomando/confRegla/:codRegla',
                            component: RuleEditorComponent,
                          },
                          {
                            path: ':codcomando/confRegla/:codRegla/historial',
                            component: ReglasHistorialComponent,
                          },
                        ],
                      },
                      {
                        path: 'negocios',
                        children: [
                          {
                            path: '',
                            component: ListadoChannelsComponent,
                            data: { ocultarNuevo: true },
                          },
                          {
                            path: ':codnegocio',
                            component: ListadoConsultaSimpleComponent,
                          },
                          {
                            path: ':codnegocio/:codcomando',
                            component: ConfigurarConsultaSimpleComponent,
                          },
                          {
                            path:
                              ':codnegocio/:codcomando/confFormulario/:codFormulario',
                            component: FormularioAtributosComponent,
                          },
                          {
                            path:
                              ':codnegocio/:codcomando/confFormulario/:codFormulario/:codAtributo',
                            component: DetalleAtributosComponent,
                          },
                          {
                            path:
                              ':codnegocio/:codcomando/confFormulario/:codFormulario/:codAtributo/:codNestForm',
                            component: FormularioAtributosComponent,
                          },
                          {
                            path: ':codnegocio/:codcomando/confRegla/:codRegla',
                            component: RuleEditorComponent,
                          },
                          {
                            path:
                              ':codnegocio/:codcomando/confRegla/:codRegla/historial',
                            component: ReglasHistorialComponent,
                          },
                        ],
                      },
                      {
                        path: 'productos',
                        children: [
                          {
                            path: '',
                            component: ListadoChannelsComponent,
                            data: { ocultarNuevo: true },
                          },
                          {
                            path: ':codnegocio',
                            component: ProductListComponent,
                            data: { ocultarNuevo: true },
                          },
                          {
                            path: ':codnegocio/:codproducto',
                            component: ListadoConsultaSimpleComponent,
                          },
                          {
                            path: ':codnegocio/:codproducto/:codcomando',
                            component: ConfigurarConsultaSimpleComponent,
                          },
                          {
                            path:
                              ':codnegocio/:codproducto/:codcomando/confFormulario/:codFormulario',
                            component: FormularioAtributosComponent,
                          },
                          {
                            path:
                              ':codnegocio/:codproducto/:codcomando/confFormulario/:codFormulario/:codAtributo',
                            component: DetalleAtributosComponent,
                          },
                          {
                            path:
                              ':codnegocio/:codproducto/:codcomando/confFormulario/:codFormulario/:codAtributo/:codNestForm',
                            component: FormularioAtributosComponent,
                          },

                          {
                            path:
                              ':codnegocio/:codproducto/:codcomando/confRegla/:codRegla',
                            component: RuleEditorComponent,
                          },
                          {
                            path:
                              ':codnegocio/:codproducto/:codcomando/confRegla/:codRegla/historial',
                            component: ReglasHistorialComponent,
                          },
                          //end region
                        ],
                      },
                    ],
                  },
                ],
              },

              {
                path: 'BuscadorProducto',
                children: [
                  { path: '', component: ProductSearchComponent },
                  {
                    path: 'nuevoBackoffice',
                    loadChildren:
                      'app/private/backoffice-products/backoffice-products.module#BackOfficeProductsModule',
                  },
                  {
                    path: 'nuevoBackoffice/:codProvider/:idSubscripcion',
                    loadChildren:
                      'app/private/backoffice-products/backoffice-products.module#BackOfficeProductsModule',
                  },
                  {
                    path: ':codnegocio/:codproducto',
                    component: ProductSearchComponent,
                  },
                ],
              },
              // TEST API
              {
                path: 'providers',
                loadChildren:
                  'app/private/providers/providers.module#ProvidersModule',
              },
              // NAVEGACION NEGOCIOS
              {
                path: 'channels',
                children: [
                  {
                    path: '',
                    component: ListadoChannelsComponent,
                  },
                  {
                    path: 'nuevo',
                    component: DetailchannelComponent,
                  },
                  {
                    path: ':codnegocio',
                    children: [
                      {
                        path: '',
                        component: EntityWithChildsComponent,
                      },
                      {
                        path: 'edit',
                        component: DetailchannelComponent,
                      },
                      {
                        path: 'authorizationConfiguration',
                        component: AuthorizationConfigurationChannelComponent,
                      },
                      {
                        path: 'buscarProductos',
                        component: ProductSearchComponent,
                      },
                      {
                        path: 'alias',
                        children: [
                          {
                            path: '',
                            component: AliasChannelComponent,
                          },
                          {
                            path: 'template',
                            component: SelectTemplateComponent,
                          },
                          {
                            path: 'template/confAssets',
                            component: ListadoAssetsComponent,
                            data: { title: 'Sponsor' },
                          },
                          {
                            path: 'template/confAssets/nuevo',
                            component: SeleccionarTipoAssetComponent,
                          },
                          {
                            path:
                              'template/confAssets/assetText/:idAsset/:codAsset',
                            component: DetalleAssetTextComponent,
                          },
                          {
                            path:
                              'template/confAssets/assetFile/:idAsset/:codAsset',
                            component: DetalleAssetFileComponent,
                          },
                        ],
                      },
                      {
                        path: 'confNegocio',
                        children: [
                          {
                            path: '',
                            component: ConfigurarChannelComponent,
                          },
                          {
                            path: 'confReport',
                            children: [
                                {
                                    path: '',
                                    component: ListReportConfigurationComponent,
                                },
                                {
                                    path: ':codreporte',
                                    component: EditReportConfigurationComponent,
                                },
                                {
                                    path: ':codreporte/mapping',
                                    component: MappingListReportConfigurationComponent,
                                },
                                {
                                    path: ':codreporte/mapping/:mappingId',
                                    component: MappingDetailsReportConfigurationComponent,
                                },
                                {
                                    path: ':codreporte/confRegla/:codRegla',
                                    component: RuleEditorComponent,
                                },
                                {
                                    path: ':codreporte/confRegla/:codRegla/historial',
                                    component: ReglasHistorialComponent,
                                }
                            ],
                        },

                          
                          //#region Business ReportConfiguration
                          // Reports Configuration (then, it can be added a command code to get or diferent kinds of documents or get
                          // diferent behaviors)
                          {
                            path: "reportSubscribe",
                            children: [
                              {
                                path: "",
                                component: ReportConfigurationSubscriptionListComponent
                                // component: ListReportConfigurationComponent
                              },
                              {
                                // for business logic configuration
                                path: "Subscription",
                                component: SubscribeReportConfigurationComponent,
                              },
                            ]
                          },
                          //#endregion
                          {
                            path: 'settings',
                            component: SettingsEntidadComponent,
                          },
                          {
                            path: 'settingChannel',
                            component: SettingChannelComponent,
                          },
                          {
                            path: 'settings/:tipo',
                            component: UserPoliciesEntidadComponent,
                          },
                          { path: 'solicitud', component: SolicitudComponent },
                          {
                            path: 'confRegla/:codRegla',
                            component: RuleEditorComponent,
                          },
                          {
                            path: 'confRegla/:codRegla/historial',
                            component: ReglasHistorialComponent,
                          },
                          {
                            path: 'confFormulario/:codFormulario',
                            component: FormularioAtributosComponent,
                          },
                          {
                            path: 'confFormulario/:codFormulario/:codAtributo',
                            component: DetalleAtributosComponent,
                          },
                          {
                            path:
                              'confFormulario/:codFormulario/:codAtributo/:codNestForm',
                            component: FormularioAtributosComponent,
                          },
                          {
                            path: 'confAssets',
                            children: [
                              { path: '', component: ListadoAssetsComponent },
                              {
                                path: 'nuevo',
                                component: SeleccionarTipoAssetComponent,
                              },
                              {
                                path: 'assetText/:idAsset/:codAsset',
                                component: DetalleAssetTextComponent,
                              },
                              {
                                path: 'assetFile/:idAsset/:codAsset',
                                component: DetalleAssetFileComponent,
                              },
                            ],
                          },
                          {
                            path: 'sxfdesigner/:codservicio/:codcomando',
                            component: SxDesigner,
                          },
                          {
                            path:
                              'sxfdesigner/:codservicio/:codcomando/:listPath',
                            component: SxDesigner,
                          },
                          {
                            path:
                              'sxfdesigner/:codservicio/:codcomando/historial/:codForm',
                            component: DesignerHistorialComponent,
                          },
                          {
                            path: 'sponsor',
                            loadChildren:
                              'app/private/sponsor/sponsor.module#SponsorModule',
                          },
                          {
                            path: 'publishB2C',
                            loadChildren:
                              'app/private/sponsor/sponsor.module#SponsorModule',
                          },
                          // NAVEGACION USUARIOS
                          // { path: 'backoffices/:codsistema/usersAndProfiles/users', component: ListadoNegociosComponent, data: { ocultarNuevo: true } },
                          {
                            path: 'usersAdmin',
                            component: ComandosUsuarioComponent,
                            data: { ocultarNuevo: true },
                          },
                          {
                            path: 'usersAdmin/import',
                            component: MassiveImportComponent,
                          },
                          {
                            path: 'usersAdmin/:codcomando',
                            component: VistaComandoComponent,
                          },
                          {
                            path: 'usersAdmin/:codcomando/:id',
                            component: VistaComandoComponent,
                          },
                          {
                            path: 'profilesAdmin',
                            component: ListadoRolComponent,
                          },
                          {
                            path: 'profilesAdmin/nuevo',
                            component: CreateRolComponent,
                          },
                          {
                            path: 'profilesAdmin/editar/:codrol',
                            component: CreateRolComponent,
                          },
                          {
                            path: 'profilesAdmin/editar',
                            component: CreateRolComponent,
                            },
                            {
                                path: 'userProfilesAdmin',
                                component: UserRolesComponent,
                            },
                          {
                            path: "userProfilesAdmin/:id",
                            component: UserRolesComponent
                          },
                          {
                            path: 'resources',
                            children: [
                              { 
                                path: '', 
                                component: ListadoResourcesComponent,
                                data: {
                                  isCustom: true
                                }
                              },
                              { 
                                path: 'new', 
                                component: DetailResourcesComponent,
                                data: {
                                  isCustom: true,
                                  isNew: true
                                }
                              },
                              { 
                                path: 'editResource/:idResource', 
                                component: DetailResourcesComponent,
                                data: {
                                  isCustom: true
                                }
                              },
                              { 
                                path: 'viewResource/:idResource', 
                                component: DetailResourcesComponent,
                                data: {
                                  isView: true
                                }
                              }
                            ]
                          }
                        ]
                      },
                      // {
                      //   path: 'digital-library',
                      //   component: DigitalLibraryListComponent,
                      // },
                      // {
                      //   path: 'digital-library/:itemid/import',
                      //   component: DigitalLibraryImportComponent,
                      // },
                      //NAVEGACION PRODUCTOS
                      {
                        path: 'products/:codproducto',
                        children: [
                          {
                            path: '',
                            component: DetailProductComponent,
                          },
                          // {
                          //   path: 'publish',
                          //   component: DigitalLibraryPublishComponent,
                          // },
                          {
                            path: 'BuscadorProducto',
                            component: ProductSearchComponent,
                          },
                          {
                            path: 'confProducto',
                            children: [
                              { path: '', component: ProductSetupComponent },
                              {
                                path: 'settings',
                                component: SettingsEntidadComponent,
                              },
                              {
                                path: 'confRegla/:codRegla',
                                component: RuleEditorComponent,
                              },
                              {
                                path: 'confRegla/:codRegla/historial',
                                component: ReglasHistorialComponent,
                              },
                              {
                                path: 'solicitud',
                                component: SolicitudComponent,
                              },
                              {
                                path: 'emails',
                                loadChildren:
                                  'app/private/product-email/product-email.module#ProductEmailModule',
                              },
                              {
                                  path: "emailSubscribe",
                                  children: [
                                    {
                                      path: "",
                                      component: ProductEmailSubscriptionListComponent
                                      // component: ListReportConfigurationComponent
                                    },
                                    {
                                      // for business logic configuration
                                      path: "Subscription",
                                      component: SubscribeProductEmailComponent,
                                    }
                                  ]
                              },
                              {
                                path: 'confFormulario/:codFormulario',
                                component: FormularioAtributosComponent,
                              },
                              {
                                path: 'confCurrency',
                                component: CurrencyConfigurationComponent,
                              },
                              {
                                  path: 'confProductReport',
                                  children: [
                                      {
                                          path: '',
                                          component: ListproductReportConfigurationComponent,
                                      },
                                      {
                                          path: ':productReportCode',
                                          children: [
                                              {
                                                  path: '',
                                                  component: DetailProductReportComponent,
                                              },                                       
                                                     
                                                      {
                                                          path: 'import',
                                                          component: ImportProductReportComponent,
                                                      },
                                                      {
                                                          path: 'confRegla/:codRegla',
                                                          component: RuleEditorComponent,
                                                      },
                                                      {
                                                          path:
                                                              'confRegla/:codRegla/historial',
                                                          component: ReglasHistorialComponent,
                                                      },
                                                      {
                                                          path: 'mapping',
                                                          component: MappingListProductReportComponent,
                                                      },
                                                      {
                                                          path: 'mapping/:mappingId',
                                                          component: MappingDetailsProductReportComponent,
                                                      },                                                
                                             
                                          ],
                                      },
                                  ],
                              },
                              {
                                path: 'productReportSubscribe',
                                children: [
                                  {
                                    path: '',
                                    component: ProductReportSubscriptionListComponent,
                                  },
                                  {
                                    // for business logic configuration
                                    path: "Subscription",
                                    component: SubscribeProductReportComponent,
                                  }
                                ],
                              },
                              {
                                path:
                                  'confFormulario/:codFormulario/:codAtributo',
                                component: DetalleAtributosComponent,
                              },
                              {
                                path:
                                  'confFormulario/:codFormulario/:codAtributo/:codNestForm',
                                component: FormularioAtributosComponent,
                              },
                              {
                                path: 'confOpciones',
                                component: ListadoOpcionesComponent,
                              },
                              {
                                path: 'confOpciones/:accion',
                                component: ControllerOpcionComponent,
                              },
                              {
                                path: 'confOpciones/:accion/:idOpcion',
                                component: ControllerOpcionComponent,
                              },

                              {
                                path: 'confAssets',
                                component: ListadoAssetsComponent,
                              },
                              {
                                path: 'confAssets/nuevo',
                                component: SeleccionarTipoAssetComponent,
                              },
                              {
                                path: 'confAssets/assetText/:idAsset/:codAsset',
                                component: DetalleAssetTextComponent,
                              },
                              {
                                path: 'confAssets/assetFile/:idAsset/:codAsset',
                                component: DetalleAssetFileComponent,
                              },
                              {
                                path: 'sxfdesigner/:codservicio',
                                component: SxDesigner,
                              },
                              {
                                path: 'sxfdesigner/:codservicio/:listPath',
                                component: SxDesigner,
                              },
                              {
                                path:
                                  'sxfdesigner/:codservicio/historial/:codForm',
                                component: DesignerHistorialComponent,
                              },
                              //#region ProductFlows
                              {
                                // for business logic configuration
                                path: 'Flow/BusinessLogic',
                                component: BusinessLogicListComponent,
                              },
                              {
                                path: 'Flow/BusinessLogic/Subscribe',
                                component: MarketplaceSubscriptionComponent,
                                data: { type: MARKETPLACE_ITEMTYPE_BusinessLogic }
                              },
                              {
                                // for the flow configuration
                                path: 'Flow/:documentKind',
                                children: [
                                  {
                                    path: '',
                                    component: ProductFlowListComponent,
                                  },
                                  {
                                   // for the import flow configuration
                                   path: 'import-flow',
                                   component: ImportDynamicFlowComponent,
                                   data: { importFlow: true }
                                  },
                                  {
                                    // for standard flow configuration
                                    path: 'standardFlows',
                                    component: ProductFlowListComponent,
                                    data: { standardFlow: true },
                                  },
                                  {
                                    path: 'standardFlows/subscribe',
                                    component: MarketplaceSubscriptionComponent,
                                    data: { type: MARKETPLACE_ITEMTYPE_StandardFlow }
                                  },
                                  {
                                    // for the flow configuration
                                    path: ':codFlow',
                                    component: ProductFlowConfigComponent,
                                  },
                                  {
                                    // for the flow configuration
                                    path: ':codFlow/dynamicStyles',
                                    component: ProductFlowDynamicStylesComponent,
                                  },
                                  {
                                    // for Flow Preview
                                    path: ':codFlow/preview',
                                    component: FlowPreviewComponent,
                                  },
                                  {
                                    // for the rule edition
                                    path:
                                      ':codFlow/interactionEvent/:eventType/:codCommand',
                                    component: IntaractionEventComponent,
                                  },
                                  {
                                    // for the rule page edition
                                    path:
                                      ':codFlow/interactionEvent/:eventType/:codCommand/:codPage',
                                    component: IntaractionEventComponent,
                                  },
                                  {
                                    // for the rule page edition
                                    path:
                                      ':codFlow/interactionEvent/:eventType/:codCommand/:codPage/historial/:codForm',
                                    component: ReglasHistorialComponent,
                                  },
                                  {
                                    path: ':codFlow/interactionEvent',
                                    redirectTo: ':codFlow',
                                  },
                                  {
                                    path:
                                      ':codFlow/interactionEvent/:eventType',
                                    redirectTo: ':codFlow',
                                  },
                                  {
                                    path: ':flowId/sxfDesigner/:pageId',
                                    component: SxDesigner,
                                  },
                                  {
                                    path: ':flowId/sxfDesigner',
                                    redirectTo: ':flowId',
                                  },
                                  {
                                    path:
                                      ':flowId/sxfDesigner/:pageId/:listPath',
                                    component: SxDesigner,
                                  },
                                  {
                                    // for the rule historial
                                    path:
                                      ':codFlow/interactionEvent/:eventType/:codCommand/historial/:codRegla',
                                    component: ReglasHistorialComponent,
                                  },
                                ],
                              },
                              /*{ // for the import flow configuration
                          path: 'Flow/Policy/import-flow',
                          component: ImportDynamicFlowComponent
                        },*/
                              //#endregion
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              // NAVEGACION TIPO SOLICITUD
              {
                path: 'tiposolicitud',
                component: ListadoTipoSolicitudComponent,
              },
              {
                path: 'tiposolicitud/:codTipoSolicitud',
                component: ConfigurarTipoSolicitudComponent,
              },
              {
                path: 'usersAndProfiles',
                component: UsersAndProfilesComponent,
              },
              // Navigation customer table
              {
                path: 'customerConfig',
                children: [
                  { path: '', component: CustomersConfiguration },
                  {
                    path: 'confRegla/:codRegla',
                    component: RuleEditorComponent,
                  },

                  // CustomerFlow
                  {
                    // for the flow configuration
                    path: 'Flow/:documentKind',
                    children: [
                      { path: '', component: ProductFlowListComponent },
                      {
                        // for the flow configuration
                        path: ':codFlow',
                        component: ProductFlowConfigComponent,
                      },
                      {
                        // for the flow configuration
                        path: ':codFlow/dynamicStyles',
                        component: ProductFlowDynamicStylesComponent,
                      },
                      {
                        // for Flow Preview
                        path: ':codFlow/preview',
                        component: FlowPreviewComponent,
                      },
                      {
                        // for the rule edition
                        path:
                          ':codFlow/interactionEvent/:eventType/:codCommand',
                        component: IntaractionEventComponent,
                      },
                      {
                        // for the rule page edition
                        path:
                          ':codFlow/interactionEvent/:eventType/:codCommand/:codPage',
                        component: IntaractionEventComponent,
                      },
                      {
                        path: ':codFlow/interactionEvent',
                        redirectTo: ':codFlow',
                      },
                      {
                        path: ':codFlow/interactionEvent/:eventType',
                        redirectTo: ':codFlow',
                      },
                      {
                        path: ':flowId/sxfDesigner/:pageId',
                        component: SxDesigner,
                      },
                      {
                        path: ':flowId/sxfDesigner',
                        redirectTo: ':flowId',
                      },
                      {
                        path: ':flowId/sxfDesigner/:pageId/:listPath',
                        component: SxDesigner,
                      },
                      {
                        // for the rule historial
                        path:
                          ':codFlow/interactionEvent/:eventType/:codCommand/historial/:codRegla',
                        component: ReglasHistorialComponent,
                      },
                    ],
                  },
                  {
                    path: 'confFormulario/:codFormulario',
                    component: FormularioAtributosComponent,
                  },
                  {
                    path: 'confFormulario/:codFormulario/:codAtributo',
                    component: DetalleAtributosComponent,
                  },
                  {
                    path:
                      'confFormulario/:codFormulario/:codAtributo/:codNestForm',
                    component: FormularioAtributosComponent,
                  },
                  {
                    path: 'sxfdesigner/:codservicio/:codcomando',
                    component: SxDesigner,
                  },
                ],
              },

              // ROUTING FOR SITE TEMPLATES
              {
                path: 'siteTemplates',
                component: ListadoSiteTemplatesComponent,
              },
              {
                path: 'siteTemplates/:codPortal',
                component: ListadoPagesComponent,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'portals',
    component: PortalsComponent,
  },
  {
    path: ':documentKind',
    data: { standardFlow: true },
    children: [
      { path: '', component: ProductFlowListComponent },
      {
        // for the import flow configuration
        path: 'import-flow',
        component: ImportDynamicFlowComponent,
        data: { importFlow: true },
      },
      { path: 'standardFlows', component: ProductFlowListComponent },
      {
        path: 'standardFlows/:codFlow',
        component: ProductFlowConfigComponent,
        data: { standardFlow: true },
      },
      {
        // for the flow configuration
        path: 'standardFlows/:codFlow/dynamicStyles',
        component: ProductFlowDynamicStylesComponent,
      },
      {
        // for Flow Preview
        path: 'standardFlows/:codFlow/preview',
        component: FlowPreviewComponent,
      },
      {
        path: 'standardFlows/:codFlow/interactionEvent',
        redirectTo: 'standardFlows/:codFlow',
      },
      {
        // for the rule edition
        path: 'standardFlows/:codFlow/interactionEvent/:eventType/:codCommand',
        component: IntaractionEventComponent,
      },
      {
        // for the rule page edition
        path:
          'standardFlows/:codFlow/interactionEvent/:eventType/:codCommand/:codPage',
        component: IntaractionEventComponent,
      },
      {
        path: 'standardFlows/:codFlow/interactionEvent',
        redirectTo: ':codFlow',
      },
      {
        path: 'standardFlows/:codFlow/interactionEvent/:eventType',
        redirectTo: ':codFlow',
      },
      {
        path: 'standardFlows/:flowId/sxfDesigner/:pageId',
        component: SxDesigner,
      },
      {
        path: 'standardFlows/:flowId/sxfDesigner',
        redirectTo: ':flowId',
      },
      {
        path: 'standardFlows/:flowId/sxfDesigner/:pageId/:listPath',
        component: SxDesigner,
      },
      {
        // for the rule historial
        path:
          'standardFlows/:codFlow/interactionEvent/:eventType/:codCommand/historial/:codRegla',
        component: ReglasHistorialComponent,
      },
      {
        // for the rule historial OnBeginStep
        path:
          'standardFlows/:codFlow/interactionEvent/:eventType/:codCommand/:id/historial/:codRegla',
        component: ReglasHistorialComponent,
      },
    ],
  },
  // DEJAR SIEMPRE ESTA RUTA AL FINAL
  { path: '**', redirectTo: '404' },
];

@NgModule({
  declarations: [
    MarketplaceComponent,
    MarketplaceSubscriptionComponent,
    MarketplaceDropdown,
    MarketplaceCard,
    MarketplaceFilter,
    NonTransactionalFlowComponent,
    NavbarComponent,
    PortalsComponent,
    PrivateSectionLayoutComponent,
    ComandosUsersSocComponent,
    HomeComponent,
    EntityInformationComponent,
    DesktopComponent,
    UsersSocComponent,
    ConfiguracionComponent,
    ComandosUsersSocComponent,
    SistemaComponent,
    ChannelComponent,
    HomeChannelConfiguracionComponent,
    ItemLibraryComponent,
    ItemLibraryListComponent,
    ItemLibraryImportComponent,
    TimelineNegocioConfiguracionComponent,
    IconsPipe,
    ContactosComponent,
    AddContacto,
    ConfigurarNuevoProductComponent,
    ConfigurarFormularioProductComponent,
    DynamicFormComponent,
    DynamicFormElementComponent,
    ...sxfDesignerModule.declarations,
    AlertComponent,
    ProductSearchComponent,
    ProductProviderListComponent,
    ProductSectionListComponent,
    DetalleOrganizacionComponent,
    DetalleSubscriptionComponent,
    DetailchannelComponent,
    ComboBoxComponent,
    HomeChannelComponent,
    ListadoSubscriptionsComponent,
    DetailProductComponent,
    HomeProductComponent,
    ListadoDesplegableComponent,
    ProductSetupComponent,
    ConfigurarTipoSolicitudComponent,
    SolicitudComponent,
    ListadoSolicitudDisponibleComponent,
    DetalleAtributosComponent,
    SolicitudComponent,
    SolicitudComponent,
    NotFoundComponent,
    ConfigurarSubscriptionComponent,
    ConfigurarOpcionesComponent,
    ListadoAssetsComponent,
    DetalleAssetTextComponent,
    DetalleAssetFileComponent,
    ListadoInitializerComponent,
    ExportarInitializerComponent,
    ImportarInitializerComponent,
    HistorialImportacionComponent,
    ListadoTipoSolicitudComponent,
    ListadoOpcionesComponent,
    TreeViewComponent,
    FormularioAtributosComponent,
    ControllerOpcionComponent,
    ConfigurarChannelComponent,
    DesignerHistorialComponent,
    SeleccionarTipoAssetComponent,
    SeleccionarNivelConsultaSimpleComponent,
    ListadoConsultaSimpleComponent,
    ConfigurarConsultaSimpleComponent,
    ParametrosListadoComponent,
    ParametroCrearComponent,
    SeleccionarTipoImportacionComponent,
    UsuarioImportacionFormComponent,
    TarifaImportacionFormComponent,
    EndosoImportacionFormComponent,
    SettingsUsuarioComponent,
    SettingChannelComponent,
    ListadoSiteTemplatesComponent,
    ListadoPagesComponent,
    SettingsEntidadComponent,
    AliasChannelComponent,
    SelectTemplateComponent,
    UserPoliciesEntidadComponent,
    ProductFlowConfigComponent,
    IntaractionEventComponent,
    ProductFlowListComponent,
    ProductStandardFlowListComponent,
    ListadoRolComponent,
    CreateRolComponent,
    UsersAndProfilesComponent,
    RolesByUserComponent,
    CustomersConfiguration,
    UserRolesComponent,
    UsersByRoleComponent,
    FlowPreviewComponent,
    ListOutputComponent,
    ListViewEngineComponent,
    DataLogicComponent,
    BusinessLogicListComponent,
    DetailOutputComponent,
    HomeOutputComponent,
    ConfigurarOutputComponent,
    ImportOutputComponent,
    ConfigurationOutputComponent,
    MappingListOutputComponent,
    PushConfigurationComponent,
    FlowPreviewComponent,
    BaseDynamicListDesignerComponent,
    ComandosUsersSocComponent,
    ListPaymentGatewaysComponent,
    DetailPaymentComponent,
    HomePaymentComponent,
    ConfigurarPaymentComponent,
    ComandosUsersSocComponent,
    MassiveImportComponent,
    ImportDynamicFlowComponent,
    JobScheduleConfigurationComponent,
    ExternalComponentListComponent,
    ExternalComponentEditComponent,
    MappingDetailsOutputComponent,
    SOCRoleListComponent,
    ListReportConfigurationComponent,
    EditReportConfigurationComponent,
    DigitalLibraryListComponent,
    DigitalLibraryImportComponent,
    CurrencyConfigurationComponent,
    DigitalLibraryProgressComponent,
    ListproductReportConfigurationComponent,
    DetailProductReportComponent,
    ConfigurarProductReportComponent,
    ImportProductReportComponent,
    MappingListProductReportComponent,
    DigitalLibraryPublishComponent,
    MappingDetailsProductReportComponent,
    MappingListReportConfigurationComponent,
    MappingDetailsReportConfigurationComponent,
    AuthorizationConfigurationChannelComponent,
    DigitalLibraryPublishComponent,
    ProductFlowDynamicStylesComponent,
    EntityListComponent,
    EntityWithChildsComponent,
    EntityInformationComponent,
    ViewEngineEditComponent,
    DetailDataLogicComponent,
    DetailBusinessLogicComponent,
    SubscribeBusinessLogicComponent,
    SOCRoleComponent,
    StandardDcitionaryComponent,
    DetailStandardDictionaryComponent,
    SubscribeReportConfigurationComponent,
    ReportConfigurationSubscriptionListComponent,
    ProductEmailSubscriptionListComponent,
    SubscribeProductEmailComponent,
    ProductReportSubscriptionListComponent,
    SubscribeProductReportComponent,
    ConfigurationCenterComponent,
    ListadoResourcesComponent,
    DetailResourcesComponent,
    ...entityWithChildsModule.declarations
  ],
  entryComponents: [
    AddContacto,
    ...sxfDesignerModule.entryComponents,
    ...entityWithChildsModule.entryComponents,
    AlertComponent,
    LoaderComponent,
    DigitalLibraryProgressComponent,
  ],
  imports: [
    NavbarModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    ReactiveFormsModule,
    NgbModule.forRoot(),
    HttpModule,
    Ng2BreadcrumbModule.forRoot(),
    ...sxfDesignerModule.imports,
    ...entityWithChildsModule.imports,
    QueryBuilderModule,
    MomentModule,
    RouterModule.forChild([
      {
        path: 'soc',
        component: PrivateSectionLayoutComponent,
        canActivate: [AuthenticatedGuard],
        children: ROUTES
      }
    ]),
    AceEditorModule,
    UsuariosModule,
    SharedModule,
    DiffMatchPatchModule,
    Ng4JsonEditorModule,
    NgxSelectModule,
    AngularDualListBoxModule,
    RulesModule,
    AutoCompleteModule,
    I18NextModule
  ],
  providers: [
    ...sxfDesignerModule.providers,
    ...entityWithChildsModule.providers,
    CacheService,
    CountryTransform,
    StyleService,
    EntitiesInformationService,
  ],
  exports: [...sxfDesignerModule.exports, ...entityWithChildsModule.exports],
})
export class PrivateSectionModule {}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/private.section.module.ts